import { Group, Select } from "@mantine/core";

import type { AccessionLogDateBasis } from "../../services/reports.service";
import { DateRange, ReportDateRangePicker } from "./ReportDateRangePicker";

interface BillingReportDateFiltersProps {
  dateBasis: AccessionLogDateBasis;
  dateRange: DateRange;
  includeDateAccessioned?: boolean;
  onDateBasisChange: (value: string | null) => void;
  onDateRangeChange: (value: DateRange) => void;
}

const DATE_BASIS_OPTIONS = [
  { value: "first_reported", label: "Date First Reported" },
  { value: "date_of_service", label: "Date of Service" },
  { value: "date_received", label: "Date Received" },
];
const ACCESSION_LOG_DATE_BASIS_OPTIONS = [
  ...DATE_BASIS_OPTIONS,
  { value: "date_accessioned", label: "Date Accessioned" },
];

export function BillingReportDateFilters({
  dateBasis,
  dateRange,
  includeDateAccessioned = false,
  onDateBasisChange,
  onDateRangeChange,
}: BillingReportDateFiltersProps) {
  return (
    <Group align="flex-end" wrap="nowrap" gap="md">
      <Select
        label="Date Filter"
        data={
          includeDateAccessioned
            ? ACCESSION_LOG_DATE_BASIS_OPTIONS
            : DATE_BASIS_OPTIONS
        }
        value={dateBasis}
        onChange={onDateBasisChange}
        allowDeselect={false}
        w={190}
      />
      <ReportDateRangePicker value={dateRange} onChange={onDateRangeChange} />
    </Group>
  );
}
